module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "grey lighten-4 pb-5",
    attrs: {
      "flat": ""
    }
  }, [(_vm.request.loading) ? _c('tombstone') : _c('transition', {
    attrs: {
      "name": "fade",
      "appear": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-2 mt-2"
  }, [(_vm.relationship && _vm.relationship.client) ? _c('client-contact-details', {
    attrs: {
      "touch": _vm.touch,
      "relationship-id": _vm.relationshipId,
      "with-edit": true,
      "with-fetch": false
    },
    model: {
      value: (_vm.relationship),
      callback: function($$v) {
        _vm.relationship = $$v
      },
      expression: "relationship"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-footer', {
    staticClass: "pl-3"
  }, [(_vm.ownerId) ? _c('sharing-information', {
    attrs: {
      "context": _vm.relationship.context,
      "owner-id": _vm.ownerId,
      "space-ids": _vm.relationship.spaces
    },
    on: {
      "click": function($event) {
        return _vm.$emit("click:share", _vm.relationship)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.initPage
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.request.loading) ? _c('tombstone', {
    attrs: {
      "height": "300px"
    }
  }) : _c('transition', {
    attrs: {
      "name": "fade",
      "appear": ""
    }
  }, [(_vm.relationship && _vm.relationship.computed_summary) ? _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.relationship.computed_summary.dates) ? _c('v-card', {
    staticClass: "ma-2",
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-text', [(_vm.formattedBio) ? _c('div', [_c('v-subheader', {
    staticClass: "pl-0 overline"
  }, [_vm._v("Bio")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedBio)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.record && _vm.record.patient && _vm.record.patient.notes) ? _c('v-divider', {
    staticClass: "mb-3"
  }) : _vm._e(), _vm._v(" "), _c('v-subheader', {
    staticClass: "pl-0 overline"
  }, [_vm._v("Highlights")]), _vm._v(" "), _c('div', [_vm._v("First appointment:\n              "), (_vm.relationship.computed_summary.dates.first) ? _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.dateformat(_vm.relationship.computed_summary.dates.first)) + "\n              ")]) : _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("None yet")])]), _vm._v(" "), _c('div', [_vm._v("Total appointments:\n              "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.relationship.computed_summary.dates.count) + "\n              ")])]), _vm._v(" "), (_vm.record && _vm.record.patient) ? [_c('div', [_vm._v("\n                Birthday:\n                "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.record.patient.date_of_birth || 'unknown') + "\n                "), (_vm.record.patient.date_of_birth) ? _c('span', [_vm._v("\n                  (" + _vm._s(_vm.age) + " years old)\n                ")]) : _vm._e()])])] : _vm._e()], 2)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.relationship.computed_summary.account) ? _c('v-card', {
    staticClass: "ma-2",
    attrs: {
      "height": "100%"
    }
  }, [(_vm.relationship.computed_summary.account.percent_paid <= 100) ? _c('v-progress-linear', {
    staticClass: "ma-0",
    attrs: {
      "value": _vm.relationship.computed_summary.account.percent_paid,
      "color": "amber"
    }
  }) : _c('v-progress-linear', {
    staticClass: "ma-0",
    attrs: {
      "value": 100,
      "color": "success"
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "subtitle-1 overline pb-0"
  }, [_vm._v("\n            Account\n            "), _c('v-spacer'), _vm._v(" "), _c('help-popover', [_vm._v("\n              These numbers are calculated based on the appointments in this account.\n\n              "), _c('v-subheader', {
    staticClass: "pa-0 overline"
  }, [_vm._v("Payments received")]), _vm._v("\n              This is the sum of all payments tracked against this user's appointments\n\n              "), _c('v-subheader', {
    staticClass: "pa-0 overline"
  }, [_vm._v("Due")]), _vm._v("\n              This is "), _c('i', [_vm._v("payments received")]), _vm._v(" - "), _c('i', [_vm._v("Total value of appointments to date")]), _vm._v(" "), _c('br'), _c('b', [_vm._v("Note:")]), _vm._v(" Future appointments are not considered \"due\"\n            ")], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('div', [_vm._v("Total value of appointments to date:\n              "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.formatnumber(_vm.relationship.computed_summary.account.value_past, true)) + "\n              ")])]), _vm._v(" "), _c('div', [_vm._v("Total value of future appointments:\n              "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.formatnumber(_vm.relationship.computed_summary.account.value_future, true)) + "\n              ")])]), _vm._v(" "), _c('div', [_vm._v("\n              Payments received:\n              "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.formatnumber(_vm.relationship.computed_summary.account.payments, true)) + "\n              ")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', [_vm._v("\n              Due:\n              "), _c('strong', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.formatnumber(_vm.relationship.computed_summary.account.value_outstanding, true)) + "\n              ")])])], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isMedical && _vm.relationship) ? _c('v-flex', [(_vm.relationship.active_codes && _vm.relationship.active_codes.length > 0) ? _c('v-list', {
    staticClass: "mt-3 mx-2 elevation-2",
    attrs: {
      "dense": "",
      "subheader": "",
      "three-line": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n        Current treatment codes\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-0",
    attrs: {
      "outline": "",
      "outlined": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("goto", "codes")
      }
    }
  }, [_vm._v("\n          Manage codes\n          "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _vm._l((_vm.relationship.active_codes), function(code) {
    return _c('treatment-log-list-item', {
      key: code.id,
      attrs: {
        "item": code,
        "with-delete": false
      }
    })
  })], 2) : _c('v-card', {
    staticClass: "mx-2 my-4"
  }, [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n        No treatment codes defined\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": "https://www.loom.com/share/f26d5537be0540f7bd8fc82c61b9b6f6",
      "target": "_blank",
      "color": "primary",
      "small": "",
      "outline": "",
      "outlined": ""
    }
  }, [_vm._v("\n              Learn more\n              "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-0",
    attrs: {
      "outline": "",
      "outlined": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("goto", "codes")
      }
    }
  }, [_vm._v("\n          Manage codes\n          "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "primary"
    }
  }, [_vm._v("info")]), _vm._v("\n        You can define treatment codes for a client and optionally have them automatically added to new\n        appointments.\n      ")], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.request.loading) ? _c('tombstone', {
    attrs: {
      "height": "300px"
    }
  }) : _c('transition', {
    attrs: {
      "name": "fade",
      "appear": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline py-0 mt-3"
  }, [_vm._v("\n          Details as they will show on invoices\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "outline": "",
      "outlined": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("goto", "record")
      }
    }
  }, [_vm._v("\n            Edit\n            "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": _vm.isMedical
    }
  }, [(_vm.relationship && _vm.relationship.client && _vm.record) ? _c('v-card', {
    staticClass: "ma-2",
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline pb-0"
  }, [_vm._v("\n            Billing information\n            "), _c('v-spacer')], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-3"
  }, [(_vm.record && _vm.record.patient && _vm.record.patient.billing_address) ? [_c('pre', {
    staticStyle: {
      "font-family": "Roboto"
    }
  }, [_vm._v(_vm._s(_vm.record.patient.billing_address))])] : [_vm._v("\n            " + _vm._s(_vm.relationship.client.first_name) + "\n            " + _vm._s(_vm.relationship.client.last_name)), _c('br'), _vm._v(" "), (_vm.isRealEmail(_vm.relationship.client.email)) ? _c('span', [_vm._v("\n              Email: " + _vm._s(_vm.relationship.client.email)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.relationship.client.phone_number) ? _c('span', [_vm._v("\n            Phone: " + _vm._s(_vm.relationship.client.phone_number)), _c('br')]) : _vm._e()]], 2)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isMedical) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.medicalaid) ? _c('v-card', {
    staticClass: "ma-2",
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline pb-0"
  }, [_vm._v("\n            Medical Aid information\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "pa-3"
  }, [_c('strong', [_vm._v(_vm._s(_vm.medicalaid.name || 'No medical aid specified'))]), _vm._v(" "), (_vm.medicalaid.scheme) ? _c('small', [_vm._v("(" + _vm._s(_vm.medicalaid.scheme) + ")")]) : _vm._e(), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Membership #:")]), _vm._v(" " + _vm._s(_vm.medicalaid.number)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Patient:")]), _vm._v(" " + _vm._s(_vm.medicalaid.patient_first_name) + " " + _vm._s(_vm.medicalaid.patient_last_name)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("ID:")]), _vm._v(" " + _vm._s(_vm.medicalaid.patient_id_number) + "\n            "), (_vm.medicalaid.is_dependent) ? _c('div', [_c('strong', [_vm._v("Main member:")]), _vm._v(" " + _vm._s(_vm.medicalaid.member_first_name) + " " + _vm._s(_vm.medicalaid.member_last_name)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("ID:")]), _vm._v(" " + _vm._s(_vm.medicalaid.member_id_number) + "\n            ")]) : _c('div', [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "success"
    }
  }, [_vm._v("check_circle")]), _vm._v("\n              Patient is main member\n            ")], 1)]), _vm._v(" "), (_vm.currentReferrers) ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Referred by:")]), _vm._v(" "), _vm._l((_vm.currentReferrers), function(referrer) {
    return _c('v-list-tile', {
      key: referrer.id
    }, [(referrer.therapist) ? _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  " + _vm._s(referrer.therapist.title) + " " + _vm._s(referrer.therapist.first_name) + " " + _vm._s(referrer.therapist.last_name) + ".\n                ")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n                " + _vm._s(referrer.therapist.reference_number) + "\n              ")])], 1)
  })], 2) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.relationship && _vm.relationship.client) ? _c('v-card', {
    staticClass: "ma-2 mt-4"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n        Danger Zone\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-dialog', {
    attrs: {
      "width": "300"
    },
    model: {
      value: (_vm.del.showConfirmation),
      callback: function($$v) {
        _vm.$set(_vm.del, "showConfirmation", $$v)
      },
      expression: "del.showConfirmation"
    }
  }, [_c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.del.window),
      callback: function($$v) {
        _vm.$set(_vm.del, "window", $$v)
      },
      expression: "del.window"
    }
  }, [_c('v-window-item', [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }), _vm._v(" "), _c('v-card-text', [_c('center', [_vm._v("\n                    Are you sure you want to "), _c('strong', [_vm._v("archive")]), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote pa-0 mt-2"
  }, [_vm._v("\n                      " + _vm._s(_vm.relationship.client.first_name) + " " + _vm._s(_vm.relationship.client.last_name) + "\n                    ")]), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-2"
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mt-3 pa-0",
    attrs: {
      "hide-details": "",
      "label": "Permanently delete"
    },
    model: {
      value: (_vm.del.permanent),
      callback: function($$v) {
        _vm.$set(_vm.del, "permanent", $$v)
      },
      expression: "del.permanent"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-0",
    attrs: {
      "hide-details": "",
      "label": "Also delete their appointments"
    },
    model: {
      value: (_vm.del.withAppointments),
      callback: function($$v) {
        _vm.$set(_vm.del, "withAppointments", $$v)
      },
      expression: "del.withAppointments"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.del.showConfirmation = false
      }
    }
  }, [_vm._v("\n                    Cancel\n                  ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.del.permanent) ? _c('v-btn', {
    attrs: {
      "loading": _vm.deleteRequest.loading,
      "color": "error"
    },
    on: {
      "click": function($event) {
        return _vm.deleteRelationship(_vm.relationship.id)
      }
    }
  }, [_vm._v("Delete")]) : _c('v-btn', {
    attrs: {
      "loading": _vm.deleteRequest.loading,
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.deleteRelationship(_vm.relationship.id)
      }
    }
  }, [_vm._v("Archive")])], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-card', [_c('v-card-text', [_c('center', [_c('v-icon', {
    attrs: {
      "color": "green",
      "size": "72"
    }
  }, [_vm._v("check_circle")]), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote pa-0 mt-2"
  }, [_vm._v("\n                      Successfully archived\n                    ")])], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "/clients",
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.del.window = 0;
        _vm.del.showConfirmation = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.isOwner,
      "loading": _vm.deleteRequest.loading,
      "color": "error"
    },
    on: {
      "click": function($event) {
        _vm.del.showConfirmation = true;
        _vm.del.window = 0
      }
    }
  }, [_vm._v("Delete")])], 1), _vm._v(" "), (!_vm.isOwner) ? _c('p', {
    staticClass: "caption mx-2"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n        Only the owner can delete this client\n      ")], 1) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16b7d1c2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/ClientIndex.vue
// module id = 1339
// module chunks = 9